<template>
  <section>
    <div class="contentBlock">
      <p class="title">重設密碼</p>
      <form @submit="resetPassword">
        <div class="formBlock">
          <label class="formLabel"
            >驗證碼
            <input
              type="text"
              name=""
              placeholder="請輸入驗證碼"
              aria-label="請輸入驗證碼"
              class="inputLayout"
              value=""
              v-model="user.passcode"
            />
          </label>
          <label class="formLabel"
            >新的密碼
            <input
              type="password"
              name=""
              aria-label="請輸入新的密碼"
              placeholder="請輸入新的密碼"
              class="inputLayout"
              value=""
              v-model="user.password"
            />
          </label>
        </div>
        <button
          @click="resetPassword"
          class="loginBtn resetLayout"
          title="重設密碼"
        >
          重設密碼
        </button>
      </form>
      <div class="additionAction">
        <router-link :to="{ name: 'login' }" title="返回登入"
          >返回登入</router-link
        >
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MemberResetPassword',
  metaInfo() {
    return {
      title: '重設密碼',
    };
  },
  data() {
    return {
      user: {
        email: '',
        passcode: '',
        password: '',
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    isInputRequired() {
      if (this.user.passcode === '' || this.user.password === '') {
        alert('請填入驗證碼和密碼');
        return false;
      }
      return true;
    },
    resetPassword(e) {
      e.preventDefault();
      if (this.isInputRequired()) {
        this.user.email = this.$store.getters.getForgotEmail;
        this.$store.dispatch('resetPassword', this.user);
        this.$router.push({ name: 'login' });
      }
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
button {
  border: none;
}
.contentBlock {
  margin: auto;
  width: 280px;
  @include for-tablet {
    width: 522px;
  }

  @include for-tablet-horizontal {
    padding-top: 40px;
  }
}

.title {
  margin: 20px 0 40px;
  font-family: $text-font-family;
  font-size: 24px;
  color: $color-light-text;
  text-align: center;
  letter-spacing: 1.71px;

  @include for-tablet {
    font-size: 32px;
    margin-top: 60px;
    margin-bottom: 100px;
  }
}

.formBlock {
  .formLabel {
    color: $color-light-text;
    font-size: 21px;
    letter-spacing: 1.71px;
    font-family: $text-font-family;
  }

  .inputLayout {
    border: 1px solid $color-light-border;
    width: 100%;
    height: 50px;
    padding: 10px 30px;
    margin-top: 10px;
    margin-bottom: 30px;
    font-size: 18px;
    color: #979797;
    border-radius: 25px;
    box-sizing: border-box;
    &::placeholder {
      color: #979797;
    }
  }
}

.loginBtn {
  width: 100%;
  padding: 10px;
  height: 50px;
  box-sizing: border-box;
  border-radius: 32px;
  cursor: pointer;
  font-size: 21px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  letter-spacing: 1.17px;
  img {
    width: 21px;
    margin-right: 10px;
  }
}

.resetLayout {
  background-color: $color-light-btn-bg;
}

.additionAction {
  text-align: center;
  margin: 10px 0 40px;

  @include for-tablet {
    margin-bottom: 60px;
  }

  a {
    color: $color-light-text;
    text-decoration: underline;
  }
}
</style>
